import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { token } from 'odyssey';

export const FancySelectBoxWrapper = styled.div`
  --fancy-select-height: 56px;
  position: relative;
  min-width: 360px;
  display: flex;
  gap: ${token('space-2')};
  background: ${token('color-white')};
  padding: ${token('space-2')};
  border-radius: ${token('border-radius-lg')};
  text-align: left;
  color: ${token('color-text-dark')};

  ${media.xs`
    min-width: 330px;
  `}

  > div:first-child {
    flex: 1;
  }

  [class$='control'] {
    min-height: var(--fancy-select-height);
    border-color: transparent;

    > *:first-child {
      margin-top: 12px;
    }
  }
`;

export const FancySelectBoxTitle = styled.label`
  pointer-events: none;
  font-size: 12px;
  position: absolute;
  left: 16px;
  top: 12px;
  z-index: 1;
  color: ${token('color-grey-3-neutral')};
`;

export const IconWrapper = styled.button`
  width: var(--fancy-select-height);
  height: var(--fancy-select-height);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${token('color-primary-brand')};
  border-radius: ${token('border-radius-lg')};
  color: ${token('color-white')};
  border: none;
  cursor: pointer;

  svg {
    width: 32px;
  }
`;
